

import { AssistantIcon } from 'lib-core'


export default AssistantIcon
